import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_LIMITS_API_BASE_URL}`;

export interface ReportColumnsResponse {
  statusCode: number;
  data: {
    status: string;
    project: {
      project_id: number;
      project_name: string;
      project_number: string;
      report_columns: {
        current: boolean;
        volts: boolean;
        travel_speed: boolean;
        true_energy: boolean;
        heat: boolean;
        wire_speed: boolean;
        oscillation_width: boolean;
        frequency: boolean;
        target: boolean;
        horizontal_bias: boolean;
        total_wire_consumed: boolean;
        arc_impedance: boolean;
        summary_page: boolean;
        is_high_low_avg_required: boolean;
      };
      units: {
        current: string;
        volts: string;
        travel_speed: string;
        true_energy: string;
        heat: string;
        wire_speed: string;
        oscillation_width: string;
        frequency: string;
        target: string;
        horizontal_bias: string;
        total_wire_consumed: string;
        band_diameter: string;
        wire_diameter: string;
        logging_distance: string;
        distance: string;
        arc_impedance: string;
        pipe_diameter: string;
        wall_thickness: string;
      };
    };
  };
  txId: string;
}

export interface ReportColumnsRequest {
  report_columns: {
    current: boolean;
    volts: boolean;
    travel_speed: boolean;
    true_energy: boolean;
    heat: boolean;
    wire_speed: boolean;
    oscillation_width: boolean;
    frequency: boolean;
    target: boolean;
    horizontal_bias: boolean;
    total_wire_consumed: boolean;
    arc_impedance: boolean;
    summary_page: boolean;
    is_high_low_avg_required: boolean;
  };
  units: {
    current: string;
    volts: string;
    travel_speed: string;
    true_energy: string;
    heat: string;
    wire_speed: string;
    oscillation_width: string;
    frequency: string;
    target: string;
    horizontal_bias: string;
    total_wire_consumed: string;
    arc_impedance: string;
    band_diameter: string;
    wire_diameter: string;
    logging_distance: string;
    distance: string;
    pipe_diameter: string;
    wall_thickness: string;
  };
}

// Get report columns configuration for a project
export const getReportColumns = async (projectId: number): Promise<ReportColumnsResponse> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/project/report-columns/${projectId}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update report columns configuration for a project
export const updateReportColumns = async (projectId: number, columns: ReportColumnsRequest): Promise<ReportColumnsResponse> => {
  try {
    const response = await axios.put(`${API_BASE_URL}/project/report-columns/${projectId}`, columns, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
